import { Locale } from 'modules/i18n';

export const translation = {
  [Locale.en]: {
    balanceTip: 'Connect to Ethereum or BNB chain to see your LBTC Balance.',
  },
};
